export const styles = () => ({
  tableCell: {
    fontSize: '0.845rem',
    paddingLeft: 6,
    paddingRight: 6
  },

  placeField: {
    maxWidth: 50,
  }
})



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingTableCell/styles.js